import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UiKitModule } from '@serviceplan/ui-kit';
import { HistoryComponent } from '../../history/history.component';

@Component({
  selector: 'thehubz-collection-history',
  templateUrl: './collection-history.component.html',
  styleUrls: ['./collection-history.component.scss'],
  standalone: true,
  imports: [CommonModule, UiKitModule, HistoryComponent],
})
export class CollectionHistoryComponent implements OnInit {
  collectionId = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    const currentPath = this.router.url.split('/');
    this.collectionId = currentPath[currentPath.length - 2];
  }
}
